import React from 'react';
import 'stylesheets/ConfirmModal.scss';
import 'stylesheets/fonts.scss';
import 'stylesheets/colors.scss';
import 'stylesheets/layout.scss';
import { FormattedMessage, injectIntl } from 'react-intl';

import {Mixpanel} from 'helpers/Mixpanel';

class CopyToWeekComponent extends React.PureComponent {
  constructor(props) {
    super(props)
    const { cancelModal, locationId, scrWeekDay, destWeekDay, destWeekLabel, ownerIds} = props;

    this.state = {
      confirmButtonEnabled: true,
      shouldIncludeOpenShifts: true,
      shouldIncludeVto: true,
    };
  }

  handleCancel = (event) => {
    const { cancelModal } = this.props;
    cancelModal();
    Mixpanel.track('Cancel copy to week');
  }


  handleCheckbox = (e) => {
    this.setState({shouldIncludeOpenShifts: e.target.checked});
  }

  handleVtoCheckbox = (e) => {
    this.setState({shouldIncludeVto: e.target.checked});
  }

  handleConfirm = (event) => {
    const { cancelModal, locationId, scrWeekDay, destWeekDay, destWeekLabel, ownerIds, copyToWeekDispatch} = this.props;
    const {confirmButtonEnabled, shouldIncludeOpenShifts, shouldIncludeVto} = this.state;

    if( confirmButtonEnabled == false ){
      return;
    }

    cancelModal();

    if(destWeekDay !== null){
      const includeVto = this.props.enableVto !== false ? shouldIncludeVto : false;
      copyToWeekDispatch(locationId, scrWeekDay, destWeekDay, ownerIds, shouldIncludeOpenShifts, includeVto);
      Mixpanel.track('Confirm copy to week', {'location_id': locationId, src_week_day: scrWeekDay, dest_week_day: destWeekDay, owner_ids: ownerIds});
    }
  }

  render() {
    const {confirmButtonEnabled, } = this.state;
    const { cancelModal, locationId, scrWeekDay, destWeekDay, destWeekLabel, ownerIds, enableVto } = this.props;

    const cancel = (<FormattedMessage id="Confirm.cancel" defaultMessage="Cancel" />);
    const confirm = (<FormattedMessage id="Confirm.confirm" defaultMessage="Confirm" />);
    const copyToWeekTitle = (<FormattedMessage id="Scheduling.copyToWeekTitle" defaultMessage='Copy Schedule to {week}' values={{week: destWeekLabel}} />);
    const copyToWeekNotes = (<FormattedMessage id="Scheduling.copyToWeekNotes" defaultMessage='Scheduled shifts and traded shifts are copied to their original owners by default.'/>);
    const includeOpenShiftText = (<FormattedMessage id="Scheduling.includeOpenShift" defaultMessage='Include open shifts' />);
    const includeVtoText = (<FormattedMessage id="Scheduling.includeVto" defaultMessage='Include Voluntary Time Off' />);

    return (
      <div className="confirm-modal-container">
        <label className="title averta-regular fs20px">{copyToWeekTitle}</label>
        <div className='body-text1'>{copyToWeekNotes}</div>
        <div className="checkbox-wrap">
          <input type="checkbox" className="checkbox" id="includeOpenShift" defaultChecked={true} onChange={this.handleCheckbox} />
          <label htmlFor="includeOpenShift" className="body-text2">{includeOpenShiftText}</label>
        </div>
        {enableVto !== false && (
          <div className="checkbox-wrap">
            <input type="checkbox" className="checkbox" id="includeVto" defaultChecked={true} onChange={this.handleVtoCheckbox} />
            <label htmlFor="includeVto" className="body-text2">{includeVtoText}</label>
          </div>
        )}

        <div className="confirm-button-wrap">
          <button className="confirm-button-cancel averta-semibold fs14px" onClick={this.handleCancel}>{cancel}</button>
          <button className={confirmButtonEnabled ? "confirm-button averta-semibold fs14px button-enabled" : "confirm-button averta-semibold fs14px button-disabled"} style={{ outline: 0 }} onClick={this.handleConfirm}>{confirm}</button>
        </div>

      </div>
    );
  }
}


export default injectIntl(CopyToWeekComponent);